<ng-container *ngIf="diner">
  <ion-header>
    <ion-toolbar mode="md"
                 color="dark">
      <ion-title>Meal Plan</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="meal-plan-modal">
      <p>
        Would <strong>{{ diner.first_name }} {{ diner.last_name}}</strong> like to
        use their meal plan or pay for their {{ isServiceAppointment ? 'service' : 'meal' }}?
      </p>
      <ion-item *ngIf="diner.meal_plan as mealplan">
        <ion-label><strong>{{ mealplan.name}}</strong></ion-label>
        <ion-label slot="end">Balance: {{ mealplan | mealPlanBalance}}</ion-label>
      </ion-item>
    </div>
  </ion-content>
  <ion-footer>
    <ion-toolbar mode="md"
                 color="light">
      <ion-buttons slot="start">
        <ion-button mode="md"
                    color="light"
                    fill="solid"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onPayForMeal()">PAY FOR {{ isServiceAppointment ? 'SERVICE' : 'MEAL'
          }}</ion-button>
      </ion-buttons>
      <ion-buttons slot="end" *ngIf="diner.meal_plan as mealplan">
        <ion-button mode="md"
                    color="dark"
                    fill="solid"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onUseMealPlan(mealplan.id)">USE
          MEAL PLAN</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>

</ng-container>
